import { START_LOADING, STOP_LOADING, SET_LOADING_TEXT } from '@/store/mutation-types';
import { ILoadingOptions } from '@/types/root';
import { Commit } from 'vuex';

const initState: ILoadingOptions = {
  isLoading: true,
  loadingText: '数据加载中'
};

const actions = {
  startLoading(context: { commit: Commit; state: ILoadingOptions }) {
    context.commit(START_LOADING, true);
  },
  stopLoading(context: { commit: Commit; state: ILoadingOptions }) {
    context.commit(STOP_LOADING, false);
  },
  setLoadingText(context: { commit: Commit; state: ILoadingOptions }, payload: string) {
    context.commit(SET_LOADING_TEXT, payload);
  }
};

const mutations = {
  [START_LOADING]: (state: ILoadingOptions, payload: boolean) => {
    state.isLoading = payload;
  },
  [STOP_LOADING]: (state: ILoadingOptions, payload: boolean) => {
    state.isLoading = payload;
  },
  [SET_LOADING_TEXT]: (state: ILoadingOptions, payload: string) => {
    state.loadingText = payload;
  }
};

const getters = {
  isLoading: (state: ILoadingOptions) => state.isLoading,
  loadingText: (state: ILoadingOptions) => state.loadingText
};

export default {
  state: initState,
  mutations,
  actions,
  getters
};
